import { WhatsAppFab } from '../components/sections/WhatsAppFab';
import { Header } from '../components/sections/Header';
import { Hero } from '../components/sections/Hero';
import { OpportunityBanner } from '../components/sections/OpportunityBanner';
import { Stats } from '../components/sections/Stats';
import { ConsumerReach } from '../components/sections/ConsumerReach';
import { HomesickMarket } from '../components/sections/HomesickMarket';
import { WhyAnz } from '../components/sections/WhyAnz';
import { WhyAtlas } from '../components/sections/WhyAtlas';
import { MarketIntelligence } from '../components/sections/MarketIntelligence';
import { HowWeLaunch } from '../components/sections/HowWeLaunch';
import { Testimonials } from '../components/sections/Testimonials';
import { PartnerJourney } from '../components/sections/PartnerJourney';
import { ForBrands } from '../components/sections/ForBrands';
import { GlobalFootprint } from '../components/sections/GlobalFootprint';
import { Faq } from '../components/sections/Faq';
import { ContactCta } from '../components/sections/ContactCta';
import { Footer } from '../components/sections/Footer';

export const Home = () => (
  <div className="min-h-screen bg-white">
    <WhatsAppFab />
    <Header />
    <Hero />
    <OpportunityBanner />
    <Stats />
    <ConsumerReach />
    <HomesickMarket />
    <WhyAnz />
    <WhyAtlas />
    <MarketIntelligence />
    <HowWeLaunch />
    <Testimonials />
    <PartnerJourney />
    <ForBrands />
    <GlobalFootprint />
    <Faq />
    <ContactCta />
    <Footer />
  </div>
);
